var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Icon from './Icon';
/**
 * Tab Component. Can be used with custom TabBar.
 *
 * **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.4.0/content/components/tabbar.md
 */
export default function Tab(_a) {
    var tab = _a.tab, index = _a.index, activeTab = _a.activeTab, stacked = _a.stacked;
    var isActive = index === activeTab;
    var icon = (typeof tab.icon === 'string')
        ? { icon: tab.icon }
        : tab.icon;
    return (React.createElement("button", { className: "madonna-tab mdc-tab " + (isActive ? 'mdc-tab--active' : '') + " " + (stacked ? 'mdc-tab--stacked' : ''), role: "tab", "aria-selected": isActive, tabIndex: isActive ? 0 : -1, onClick: function () { } },
        React.createElement("span", { className: "mdc-tab__content" },
            icon && React.createElement(Icon, __assign({}, icon, { "aria-hidden": true })),
            React.createElement("span", { className: "mdc-tab__text-label" }, tab.label)),
        React.createElement("span", { className: "mdc-tab-indicator " + (isActive ? 'mdc-tab-indicator--active' : '') },
            React.createElement("span", { className: "mdc-tab-indicator__content mdc-tab-indicator__content--underline" })),
        React.createElement("span", { className: "mdc-tab__ripple" })));
}
//# sourceMappingURL=Tab.js.map